import { Environment } from './environment.tpl';

enum KnownChannelIds {
  BaseballEurope = 'iyhmqq8DaULcNVEyIadi',
  BasketballIreland = '0AYlDfFb7OtdRQfjgbQ2',
  BritishWeightlifting = 'wqGgg0ziUoOhX4NVjMLm',
  BUCS = '9wwo2harPwaUfNXpyTtO',
  EnglandHockey = 'LBkaX3u8sJUbg2GpxTo1',
  EnglandNetball = '8qRfXG1IprJvJTK6HZNT',
  GBBasketball = 'qMRVy28NKhtuR4znSccl',
  JudoCanada = 'adKRUey5k6UVEH3HsmAG',
  NationalFutsal = 'V2rYrySrlRzPJxpn90GX',
  TableTennisEngland = 'QaVzbVlrp8deh9ojYgtZ',
  USATeamHandball = 'yxc7Po2qza2o5ZvJ2ZQY',
  WorldArchery = 'jcuiiq6fmjXY0kAEIfCo',
  Eiba = 'iuoMRf7eDQhixN1WYU56',
  USATF_THROW_AWAY = 'TjKjcF12EAkYyhyeZJV4',
  USATF = 'c93kHpPTdS7BS7zIyQ7C',
}

export const environment: Environment = {
  joymo: {
    authUrl: 'https://auth.joymo.no',
    defaultSupportEmail: 'support@joymo.tv',
  },
  firebase: {
    apiKey: 'AIzaSyBbJpFMDN8DpGCPGMyt_D7Ki609eyiCGwY',
    authDomain: 'auth.joymo.no',
    databaseURL: 'https://yoimo-live-production.firebaseio.com',
    projectId: 'yoimo-live-production',
    storageBucket: 'yoimo-live-production.appspot.com',
    messagingSenderId: '102685381919',
    appId: '1:102685381919:web:66113b7e241a3dfcc04c2a',
    measurementId: 'G-KT9LWM3V2D',
    locationId: 'us-central1',
  },
  production: true,
  emulator: false,
  behavior: {
    defaultIcon: 'joymo',
    betaDomains: ['bucs.tv', 'gbbasketball.tv'],
    cacheMaxAge: 600,
    redirectToCanonicalUrl: true,
    defaultDomain: 'app.joymo.tv',
    emulateDomain: null,
    domainAliases: {},
    defaultTheme: {
      accentColor: '#00A83C',
      backgroundColor: '#ffffff',
      themeStyle: 'rounded',
    },
    testFeatures: {
      channelsWithVideoFeedback: [
        KnownChannelIds.BaseballEurope,
        KnownChannelIds.BasketballIreland,
        KnownChannelIds.BUCS,
        KnownChannelIds.EnglandHockey,
        KnownChannelIds.GBBasketball,
      ],
      favicons: {
        default: 'assets/favicons/joymo.png',
        [KnownChannelIds.BasketballIreland]:
          'assets/favicons/basketballireland.png',
        [KnownChannelIds.BaseballEurope]: 'assets/favicons/wbsceurope.png',
        [KnownChannelIds.BritishWeightlifting]: 'assets/favicons/bwl.png',
        [KnownChannelIds.BUCS]: 'assets/favicons/bucs.png',
        [KnownChannelIds.EnglandHockey]: 'assets/favicons/englandhockey.png',
        [KnownChannelIds.EnglandNetball]: 'assets/favicons/englandnetball.png',
        [KnownChannelIds.GBBasketball]: 'assets/favicons/gbbasketball.png',
        [KnownChannelIds.JudoCanada]: 'assets/favicons/judocanada.png',
        [KnownChannelIds.NationalFutsal]: 'assets/favicons/nationalfutsal.png',
        [KnownChannelIds.TableTennisEngland]:
          'assets/favicons/tabletennisengland.png',
        [KnownChannelIds.USATeamHandball]: 'assets/favicons/usath.png',
        [KnownChannelIds.WorldArchery]: 'assets/favicons/archery.png',
        [KnownChannelIds.Eiba]: 'assets/favicons/eiba.png',
        [KnownChannelIds.USATF_THROW_AWAY]:
          'assets/favicons/Website_USATF-TV_Logo.png',
        [KnownChannelIds.USATF]: 'assets/favicons/Website_USATF-TV_Logo.png',
      },
    },
  },
  sentry: {
    browser:
      'https://0f41f2c4c0a6401683a88bac3749e554@o1234650.ingest.sentry.io/6384077',
  },
  google: {
    analytics: {
      gtmId: 'GTM-W8BZDBW',
    },
  },
  enableRouterTracing: false,
  videoAnalytics: {
    accountCode: 'joymo',
    enabled: true,
    debug: [
      'R8Xob4RSO9ggTEuqThAFZN5soTS2',
      'LGn1gITPM2ZtrBH5qC7eR4i9pbN2',
      'PD3rHuxBOvO80Dci1N9fu1ieh0R2',
    ],
    options: {
      'content.customDimension.Dimension1': '',
    },
  },
};
